<div class="not-found mt-5">
    <header>
        <img src="/assets/img/brand/mymeds-logo-full.svg" alt="MyMedsPH Logo">
        <h1>MyMedsPH</h1>
    </header>
    <section class="content mt-5">
        <h2 class="m-3">Sorry! Domain Not Found.</h2>
        <h3 class="expired">You are trying to access the link "{{this.domainPage}}" but it is not yet registered to our system.</h3>
        <h4 class="contact mt-4">Would you like to register this domain or go back to our default page!</h4>
        <div class="row justify-content-center mt-3">
            <div class="col-12 col-sm-6 col-md-3 mb-3">
              <button type="button" class="btn btn-raised btn-success w-100 hover-btn" (click)="register()">Register</button>
            </div>
            <div class="col-12 col-sm-6 col-md-3 mb-3">
              <button type="button" class="btn btn-raised btn-danger w-100 hover-btn" (click)="redirectToDefaultPage()">Go to Default Page</button>
            </div>
          </div>          
    </section>
</div>
<footer>
    <p>
        <a href="https://mymedsph.com/ ">MyMedsPH</a> &nbsp;&nbsp;&nbsp;&nbsp; 0917 705 7827
        &nbsp;&nbsp;&nbsp;&nbsp; info@mymedsph.com
    </p>
</footer>
